import axios from 'axios';
import Cookies from 'js-cookie';
import { auth } from '../config/firebase';

const axiosInstance = axios.create({
  baseURL: '/api/',
  headers: { 'Content-Type': 'application/json' }
});

// The headers every API request needs: the workspace the user is working in
// and a freshly minted bearer token. Exported for callers that read the
// response themselves with `fetch` (streaming, which axios cannot do) and so
// cannot go through this instance's interceptor.
export const applyAuthHeaders = async (headers) => {
  const activeWorkspaceId = window.localStorage.getItem('activeWorkspaceId');
  if (activeWorkspaceId) {
    headers['x-workspace-id'] = activeWorkspaceId;
  }

  if (auth.currentUser) {
    headers.Authorization = await auth.currentUser
      .getIdToken()
      .then((idToken) => {
        return idToken;
      })
      .catch(() => {
        return '';
      });
  }

  return headers;
};

axiosInstance.interceptors.request.use(async (request) => {
  await applyAuthHeaders(request.headers);

  return request;
});

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response.status === 401) {
      Cookies.remove('auth');
      window.location.href = '/signin';
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
